import { render, staticRenderFns } from "./manageRole.vue?vue&type=template&id=18f19d14&"
import script from "./manageRole.vue?vue&type=script&lang=js&"
export * from "./manageRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports